<template>
  <div class="row cart-item">
    <div class="item-details item-details-name" :class="discount?'col-8':'col-9'">
      <select
        v-show="!cartItem.reedemptionRule"
        id="qty-dropdown"
        class="cart-qty-dropdown"
        @change="updateQt($event)"
      >
        <option
          v-for="num in qtyNumbers"
          :key="num.ID"
          :id="'option-' + num"
          :selected="num == cartItem.quantity"
        >{{ num }}</option>
      </select>
      <div v-show="cartItem.reedemptionRule" class="cart-qty-empty-mobile"></div>
      <span class="d-flex">{{ cartItem.name | camelCase }}</span>
      <small v-if="cartItem.modifiers">
        <template v-for="(md, index) in flatCartItemModifiers(cartItem.modifiers)">
          {{ md.Name }}({{md.quantity}})
          <template v-if="cartItem.modifiers.length > index + 1">,</template>
        </template>
        <div>
          <a
            href="#"
            :style="mobileStyles.LinkColorTxt"
            @click.prevent="removeCartItem(cartItem)"
          >{{ $t('message.remove') }}</a>
        </div>
      </small>
    </div>
    <div v-if="!discount" class="col-3 item-price">
      <div>{{ price | formatMoney }}</div>
      <div v-if="getPoints " class="item-points text-success">
        <span>({{getPoints | formatNumber}} pts)</span>
      </div>
    </div>
    <div class="col-4 item-price" v-else>
      <strike class="fs-75 pr-2">{{ price | formatMoney }}</strike>
      <span>{{discount| formatMoney}}</span>
      <div v-if="getPoints" class="item-points text-success">
        <span>({{getPoints | formatNumber}} pts)</span>
      </div>
    </div>
    <div v-if="rollInto" class="col-md-12">
      <div v-for="rt in rollInto.selectedRollIntos" :key="rt.ID">
        <a
          class="run-into-meal-btn row"
          @click="editRollInto(rt)"
          :style="mobileStyles.roolIntoButton"
        >
          <div class="col-9 item-details item-details-name roll-into-mobile">
            <span class="d-flex roll-into-mobile-name">{{ rollInto.Name | camelCase }}</span>
            <small v-if="rt.selectedModifiers" :style="mobileStyles.primaryColor">
              <template v-for="(md, index) in rt.selectedModifiers">
                {{ md.Name }}({{md.quantity}})
                <template
                  v-if="rt.selectedModifiers.length > index + 1"
                >,</template>
              </template>
            </small>
          </div>
          <div class="col-3 item-price">{{ rt.appliedDiscount | formatMoney }}</div>
        </a>
        <div
          v-if="getRollIntoPoints(rt)"
          class="roll-item-point"
          :style="mobileStyles.primaryColor"
        >({{ getRollIntoPoints(rt) | formatNumber}} pts)</div>
      </div>
      <div v-if="getNewRollInto" class="h-100">
        <a
          class="run-into-meal-btn row"
          @click="addrollInto()"
          :style="mobileStyles.roolIntoButton"
        >
          <div class="col-12 item-details item-details-name roll-into-mobile-empty">
            <span class="d-flex roll-into-mobile-name">{{ getNewRollInto.Name | camelCase }}</span>
          </div>
        </a>
      </div>
    </div>

    <modal
      class="mt-5"
      ref="rollIntoModal"
      v-if="showRollInto"
      full-header
      @close="closeModal"
      hide-footer
    >
      <template slot="body">
        <div
          class="cart-item"
          style="height: calc(100vh - 170px);overflow-y: auto;margin-bottom: 50px;"
        >
          <Modifiers
            :price-trigger="rollInto"
            @canceled="closeModal"
            :product="rollIntoParams.product"
            :modifiers="rollIntoParams.modifiers"
            :product-id="rollIntoParams.productId"
            @updated="selectRollIntoModiefiers"
            :initial-modifiers="initialModifier(selectedIndex)"
            :rollinto-index="selectedIndex"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/shopping-cart/CartItem.js";
import { priceTriggerType } from "../../../api/constants/priceTriggerEnums";
import Modifiers from "../products/Modifiers";
import modal from "../../modal";
import { mapGetters } from "vuex";
export default {
  components: { modal, Modifiers },
  props: {
    cartItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qtyNumbers: [],
      showRollInto: false,
      selectedRollIntoModiefiers: []
    };
  },
  watch: {
    "cartItem.quantity": function() {
      if (this.rollInto) {
        this.fixRollIntoQuantity();
      }
    }
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "mobileStyles",
      "storeMenu",
      "getPriceTriggerOutcomes",
      "canshowRollInto",
      "applicableLoyalityRule",
      "useStampCollection"
    ]),
    showRollIntoProduct() {
      if (this.rollInto)
        return this.canshowRollInto({
          ...this.menuCopy.Products[this.cartItem.id],
          quantity: this.cartItem.quantity,
          index: this.rollInto.selectedRollIntos.length
        });
      return null;
    },
    rollInto() {
      var result = this.getPriceTriggerOutcomes.find(
        oc =>
          oc.order == this.cartItem.uniqueId &&
          oc.type == priceTriggerType.rollIntoMealPriceTriggers
      );
      if (result && !result.selectedRollIntos) result.selectedRollIntos = [];
      return result;
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      return {
        product: this.menuCopy.Products[
          this.rollInto.rollIntoProduct.ProductID
        ],
        modifiers: this.menuCopy.ModifierGroups,
        productId: this.rollInto.rollIntoProduct.ProductID
      };
    },
    getNewRollInto() {
      if (
        this.rollInto &&
        this.cartItem.quantity > this.rollInto.selectedRollIntos.length
      ) {
        return this.showRollIntoProduct;
      } else return null;
    }
  },
  created() {
    shared.createdComponent(this);
  },
  methods: {
    ...shared.methods
  }
};
</script>
